import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import { EvidenceProvider } from "@context/shared/EvidenceContext";
import {
  NotificationProvider,
  useNotificationContext,
} from "@context/NotificationContext";
import CreateNotificationWorkflow from "@components/form/notification/CreateNotificationWorkflow";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const CreateNotification = () => {
  return (
    <NotificationProvider>
      <EvidenceProvider>
        <Consumer />
      </EvidenceProvider>
    </NotificationProvider>
  );
};

const Consumer: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { handleChangeDetails } = useNotificationContext();
  const subscriberIds = searchParams.get("subscriberIds")?.split(",") || [];
  const notificationId = searchParams.get("notificationId") || "";

  useEffect(() => {
    handleChangeDetails("subscriberIds", subscriberIds);
    handleChangeDetails("notificationId", notificationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      permissions={["CreateNotifications", "CreateMessages"]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: t("notification.new_notification"),
        },
      ]}
      title={t("notification.new_notification")}
    >
      <CreateNotificationWorkflow />
    </Layout>
  );
};

export default CreateNotification;
